import * as React from 'react';
import { TeamMemberTableRowData, TeamTableRowType } from '../types';
import { getInitials } from '../services/row-helper';
import { Avatar } from 'wix-style-react';

interface Props {
  profileImage: string;
  rowData: TeamMemberTableRowData;
}

export class UserImage extends React.Component<Props> {
  render() {
    const { profileImage, rowData } = this.props;
    return <Avatar
      dataHook="user-image"
      ariaLabel={`Avatar for ${'placeholder name'}`}
      color={undefined}
      text={rowData.type === TeamTableRowType.user ? getInitials(rowData) : undefined}
      imgProps={{ src: profileImage }}
      size={undefined}
    />;
  }
}
